module.exports = __webpack_public_path__ + "assets/web_small.c6db70cd007e6a056fbb61057c19b202.png";


/*****************
 ** WEBPACK FOOTER
 ** ./img/web_small.png
 ** module id = 121
 ** module chunks = 0
 **/